import { render, staticRenderFns } from "./RejectedComponent.vue?vue&type=template&id=0b6f0695&scoped=true&"
import script from "./RejectedComponent.vue?vue&type=script&lang=js&"
export * from "./RejectedComponent.vue?vue&type=script&lang=js&"
import style0 from "./RejectedComponent.vue?vue&type=style&index=0&id=0b6f0695&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6f0695",
  null
  
)

export default component.exports